import { ReactNode } from 'react';
import ReactModal from 'react-modal';
import Color, { BackgroundColors } from '../../utilities/Color.js';
import Icon from '../Icon/index.js';
import Typography from '../Typography/index.js';

export interface ModalProps {
  title: ReactNode;
  children: ReactNode;
  isOpen: boolean;
  onClickClose: () => void;
  size?: 'S' | 'M' | 'L';
  preventClose?: boolean;
}

const ModalSizes = {
  S: 'max-w-[35rem]',
  M: 'max-w-[52rem]',
  L: 'max-w-[75rem]',
};

export default function Modal({
  title,
  children,
  isOpen,
  size = 'S',
  onClickClose,
  preventClose = false,
}: ModalProps): JSX.Element {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClickClose}
      overlayClassName={`fixed inset-px z-50 ${
        BackgroundColors[Color.Overlay]
      } bg-opacity-75 backdrop-filter backdrop-blur-sm`}
      className={`relative m-auto my-4 ${
        ModalSizes[size]
      } max-h-[calc(100vh-2rem)] rounded-lg overflow-auto ${BackgroundColors[Color.White]}`}
      {...(preventClose && {
        shouldCloseOnOverlayClick: false,
        shouldCloseOnEsc: false,
      })}
    >
      <>
        <button
          type="button"
          className="cursor-pointer absolute top-5 right-5"
          aria-label="close"
          onClick={onClickClose}
          disabled={preventClose}
        >
          <Icon type="close" size="LG" color={Color.Text} />
        </button>
        <div className="pt-8 px-16 pb-8">
          <Typography variant="h2" tag="h2">
            {title}
          </Typography>
          <div className="pt-6 pb-4">{children}</div>
        </div>
      </>
    </ReactModal>
  );
}
